<template>
  <CDropdown variant="nav-item">
    <CDropdownToggle placement="bottom-end" class="py-0" :caret="false">
      <CAvatar :src="avatar" size="md" />
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <CDropdownHeader component="h6" class="bg-light fw-semibold py-2">
        Twoje konto
      </CDropdownHeader>
      <CDropdownItem @click="logout">
        <CIcon icon="cil-lock-locked" /> Wyloguj
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
export default {
  name: 'AppHeaderDropdownAccnt',
  data() {
    return {
      avatar: '/img_avatar.png',
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch('logout')

      this.$router.push('/auth/login')
    },
  },
}
</script>
